
import React from 'react';
import './App.css'
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Header from './components/Header';
import Hero from './components/Hero';
import Services from './components/Services';
import Specialists from './pages/Specialists';
import AboutSection from './components/AboutSection';
import Booking from './pages/Booking';
import Testimonials from './components/Testimonials';
import Gallery from './components/Gallery';
import Blog from './pages/Blog';
import FAQ from './pages/FAQ';
import Contact from './pages/Contact';
import PrivacyPolicy from './pages/PrivacyPolicy';
import Footer from './components/Footer';
import BackToTopButton from './components/BackToTopButton';
import About from './pages/About';
import Terms from './pages/Terms';
import Legal from './pages/Legal';

// Home component that contains the main page sections
const Home = () => (
  <>
    <Hero />
    <AboutSection />
    <Services />
    <Gallery />
    <Testimonials />
  </>
);

const App: React.FC = () => {
  return (
    <div style={{ fontFamily: '"Inter", sans-serif' }} className="text-gray-800 dark:text-gray-200">
      <Router>
        <Header />
        <main>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/about" element={<About />} />
            <Route path="/services" element={<Services />} />
            <Route path="/specialists" element={<Specialists />} />
            <Route path="/blog" element={<Blog />} />
            <Route path="/faq" element={<FAQ />} />
            <Route path="/booking" element={<Booking />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/privacy-policy" element={<PrivacyPolicy />} />
            <Route path="/terms" element={<Terms />} />
            <Route path="/legal" element={<Legal />} />
          </Routes>
        </main>
        <Footer />
        <BackToTopButton />
      </Router>
    </div>
  );
};

export default App;
